import { app } from "../App";
import {
  Button,
  Grid,
  Paper,
  styled,
  Typography
  } from "@mui/material";
import { getAuth, signOut } from "firebase/auth";
import { useNavigationHelper } from "../hooks/useNavigationHelper";

const Container = styled("div")(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  height: "100vh",
  justifyContent: "center",
  padding: theme.spacing(2),
}));

export default function ThankYouPage() {
  const { goToMainRoot } = useNavigationHelper();
  const auth = getAuth(app);

  const handleGoToLogin = async () => {
    try {
      if (auth.currentUser) {
        await signOut(auth);
      }
    } catch (e) {
      // ignorujemy błąd wylogowania – i tak przejdziemy do ekranu logowania
      console.warn("Błąd wylogowania przed przejściem do logowania:", e);
    } finally {
      goToMainRoot();
    }
  };

  return (
    <Container>
      <Grid container height="100vh" justifyContent="center" alignItems="center">
        <Grid item>
          <Paper sx={{ p: 4, minWidth: "400px", textAlign: "center" }}>
            <Grid container direction="column" spacing={3} alignItems="center">
              <Grid item xs={12}>
                <Typography variant="h4" component="h1" gutterBottom>
                  Dziękujemy za rejestrację!
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" color="text.secondary">
                  Twoje konto zostało utworzone i jest gotowe do użycia.
                </Typography>
                <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                  Aby rozpocząć pracę w systemie, przejdź do strony logowania i zaloguj się danymi podanymi przy rejestracji.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Button variant="contained" onClick={handleGoToLogin} size="large">
                  Przejdź do logowania
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}
